import React, { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { UploadFormInput } from './upload.model';
import { useValidationMessages } from './upload.hooks';

interface UploadFormTosProps {
    required: boolean;
    disabledOnEmbed: boolean;
    isEmbed: boolean;
    accepted: boolean;
    tosUrl: string;
    onChange: (input: Partial<UploadFormInput>) => void
}

const UploadFormTos = ({ required, disabledOnEmbed, isEmbed, accepted, tosUrl, onChange }: UploadFormTosProps): ReactElement => {
    const validationMessages = useValidationMessages();
    return (
        <>
            { !isEmbed || !disabledOnEmbed ?
                <div className="mt-4 mb-4 tracking-tight sm:tracking-normal">
                    { !required ?
                        <Trans i18nKey="tosAgreeByClicking">
                            By clicking Upload you agree to the <a
                                className="upload-link font-bold underline"
                                href={ tosUrl || 'https://portal.greenfly.com/termsofservice-engage' }
                                target="_blank"
                                rel="noopener noreferrer"
                            >terms and conditions</a>.
                        </Trans> :
                        <>
                            <input id="tos-required"
                                name="tos-required"
                                type="checkbox"
                                checked={accepted}
                                required
                                onChange={(e) => onChange({ termsAcknowledged: e.target.checked })}
                                onInvalid={validationMessages.onInvalid}
                                onInput={validationMessages.onInput}
                            />
                            <label className="ml-2 rtl:ml-0 rtl:mr-2" htmlFor="tos-required">
                                <Trans i18nKey="tosAgreeCheckbox">
                                    I have read and agree to the <a
                                        className="upload-link font-bold underline"
                                        href={ tosUrl || 'https://portal.greenfly.com/termsofservice-engage' }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >terms and conditions</a>.
                                </Trans>
                            </label>
                        </>
                    }
                </div> : null }
        </>
    );
};

export default UploadFormTos;
